import { Map, List } from 'immutable';
import Constants from '../../constants';
import { ACTION_ERROR } from '../../constants/action-status';
import reducerChain from '../helpers/chain';

export const DEFAULT_STATE = Map({
	fields: {
		questionTitle: false,
		questionTopic: false,
		topicNameField: false,
	},
	displayMessages: false,
	messages: List([]),
});

const createErrorListForPayload = (dispatchedAction) =>
	Array.isArray(dispatchedAction.payload)
		? List(dispatchedAction.payload)
		: List([dispatchedAction.payload]);

const resetErrors = (state = DEFAULT_STATE, action) => {
	if (action.type === Constants.RESET_ERRORS) {
		return DEFAULT_STATE;
	}
	return state;
};

const dismissFlag = (state = DEFAULT_STATE, action) => {
	if (action.type === Constants.DISMISS_FLAG) {
		return state.withMutations((state) => {
			const messages = state.get('messages');
			const filteredMessages = messages.filter(
				(msg) => msg.messageKey !== action.payload.messageKey,
			);

			// update messages if only there is update
			if (messages.size != filteredMessages.size) {
				state.set('messages', filteredMessages);
				state.set('displayMessages', filteredMessages.size > 0);
			}
		});
	}
	return state;
};

const errors = (state = DEFAULT_STATE, action) => {
	if (action.type.includes(ACTION_ERROR) || action.type.includes(Constants.ACTION_MESSAGE)) {
		return state.withMutations((state) => {
			const oldMessages = state.get('messages') || List();
			const newMessages = createErrorListForPayload(action).filter(
				(newMessage) => !oldMessages.includes(newMessage),
			);

			state.set('displayMessages', true);
			state.set('messages', oldMessages.concat(newMessages));
			action.params.fields && state.set('fields', action.params.fields);
		});
	}
	return state;
};

export default reducerChain([errors, resetErrors, dismissFlag], DEFAULT_STATE);
